import{getConditionResult as n}from"./getConditionResults.js";const e=({condition:t,children:o})=>!!n(t)&&o?o:null;export{e as When};
